import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {RestAPIMethods} from './rest-api-methods';

@Injectable({
  providedIn: 'root'
})
export class OriginRestAPIService {
  configApi = new RestAPIMethods(this.http, 'config/api/v1/');
  sparkplugApi = new RestAPIMethods(this.http, 'sparkplug/api/v1/');
  dsApi = new RestAPIMethods(this.http, 'ds/api/v1/');
  alarmsApi = new RestAPIMethods(this.http, 'events/api/v1/');

  constructor(private http: HttpClient) {}
}
